// @flow

import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'settings',
  `
  PROMPT_TO_CONFIRM_DATA_DELETION
  DISMISS_DATA_DELETION_CONFIRMATION
  CANCEL_DATA_DELETION
  `
);
